import { Button, Icon } from '@toggle/design-system';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { appPaths } from '~/routes/app-paths';
import { useChat } from '~/stores/use-chat/useChat';
import { RenderChatSubmitProps } from '~/views/widgets/Widgets';

import * as S from './EarningsChatSubmit.styles';

interface EarningsChatSubmitProps {
  renderChatSubmit?: (props?: RenderChatSubmitProps) => ReactElement;
  documentIds?: string[];
}

export const EarningsChatSubmit = ({
  renderChatSubmit,
  documentIds,
}: EarningsChatSubmitProps) => {
  const { t } = useTranslation(['intel', 'asset-overview']);
  const navigate = useNavigate();

  const { messages, isMessagePending } = useChat(state => ({
    messages: state.messages,
    isMessagePending: state.isMessagePending,
  }));

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const messagePendingLog = useRef([isMessagePending]);

  const renderChatSubmitProps: RenderChatSubmitProps = {
    placeholder: t('intel:placeholder'),
    chatContext: { target: 'document-assistant', documents: documentIds },
    disableEditingOnMessagePending: true,
    persistInputTextOnSubmit: true,
    clearDocumentContextOnSubmit: true,
  };

  useEffect(() => {
    messagePendingLog.current.push(isMessagePending);
  }, [isMessagePending]);

  useEffect(() => {
    const docMessage = messages.find(
      item => item.target === 'document-assistant'
    );
    const isNewMessageSent =
      !isMessagePending &&
      messagePendingLog.current[messagePendingLog.current.length - 2];

    if (docMessage && isNewMessageSent) {
      navigate(appPaths.alfred);
    }
  }, [isMessagePending, messages, navigate]);

  return (
    <div>
      <S.ChatSubmitWrapper onClick={() => setIsSearchOpen(true)}>
        <S.StyledInput
          leftIcon={
            <S.AlfredIconWrapper>
              <Icon iconName="AlfredNav" size={24} />
            </S.AlfredIconWrapper>
          }
          rightIcon={
            <Button label={t('asset-overview:documentSearch.askQuestion')} />
          }
          placeholder={t('asset-overview:documentSearch.buttonText')}
        />
      </S.ChatSubmitWrapper>
      <S.StyledModal
        isOpen={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
        description={
          !!renderChatSubmit && renderChatSubmit(renderChatSubmitProps)
        }
      />
    </div>
  );
};
